<template>
  <div class="advert-manage-container">
    <el-card class="search-wrapper">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ isPropertyMode ? "轮播图查询" : $t("advertManage.search.title") }}</span>
        <el-button
          v-if="!isPropertyMode"
          style="float: right; padding: 3px 0"
          type="text"
          @click="toggleMoreCondition"
        >
          {{
            advertManageInfo.moreCondition
              ? $t("advertManage.search.hide")
              : $t("advertManage.search.more")
          }}
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input
            v-model="advertManageInfo.conditions.adName"
            :placeholder="$t('advertManage.search.adNamePlaceholder')"
            clearable
          />
        </el-col>
        <el-col v-if="isPropertyMode" :span="4">
          <el-select
            v-model="advertManageInfo.conditions.communityId"
            placeholder="请选择小区"
            clearable
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="item in managedCommunities"
              :key="item.communityId"
              :label="item.name"
              :value="item.communityId"
            />
          </el-select>
        </el-col>
        <el-col v-if="!isPropertyMode" :span="4">
          <el-select
            v-model="advertManageInfo.conditions.classify"
            :placeholder="$t('advertManage.search.classifyPlaceholder')"
            clearable
          >
            <el-option
              v-for="item in classifyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-col>
        <el-col v-if="isPropertyMode" :span="4">
          <el-select
            v-model="advertManageInfo.conditions.clientType"
            placeholder="请选择投放客户端"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in clientTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-col>
        <el-col v-if="isPropertyMode" :span="4">
          <el-select
            v-model="advertManageInfo.conditions.effectiveState"
            placeholder="请选择投放状态"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in effectiveStateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="queryAdvert">{{
            $t("common.search")
          }}</el-button>
          <el-button @click="resetAdvert">{{ $t("common.reset") }}</el-button>
        </el-col>
      </el-row>
      <el-row
        v-show="!isPropertyMode && advertManageInfo.moreCondition"
        :gutter="20"
        style="margin-top: 15px"
      >
        <el-col :span="4">
          <el-select
            v-model="advertManageInfo.conditions.locationTypeCd"
            :placeholder="$t('advertManage.search.locationPlaceholder')"
            clearable
          >
            <el-option
              v-for="item in advertManageInfo.locationTypeCds"
              :key="item.statusCd"
              :label="item.name"
              :value="item.statusCd"
            />
          </el-select>
        </el-col>
      </el-row>
    </el-card>

    <el-alert
      v-if="isPropertyMode && contextLoaded && managedCommunities.length === 0"
      title="当前账号未分配可管理小区，请联系物业管理员"
      type="warning"
      :closable="false"
      show-icon
      style="margin-bottom: 20px"
    />

    <el-card class="list-wrapper">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ isPropertyMode ? "轮播图管理" : "广告管理" }}</span>
        <div style="float: right">
          <el-button
            type="primary"
            size="small"
            :disabled="!contextLoaded || (isPropertyMode && managedCommunities.length === 0)"
            @click="openAddAdvert"
          >{{ isPropertyMode ? "新增轮播图" : $t("advertManage.list.publish") }}</el-button>
          <!-- <el-button type="primary" size="small" @click="viewAdvertPhoto">{{ $t('advertManage.list.viewAdvert')
          }}</el-button> -->
        </div>
      </div>

      <el-table
        v-loading="loading"
        :data="advertManageInfo.adverts"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="advertId"
          :label="$t('advertManage.table.advertId')"
          align="center"
        />
        <el-table-column
          prop="adName"
          :label="$t('advertManage.table.adName')"
          align="center"
        />
        <el-table-column label="素材" align="center" width="100">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.coverUrl"
              :src="scope.row.coverUrl"
              :preview-src-list="[scope.row.coverUrl]"
              fit="cover"
              style="width: 72px; height: 40px; border-radius: 4px"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="classifyName"
          :label="$t('advertManage.table.classify')"
          align="center"
        />
        <el-table-column
          prop="communityName"
          label="投放小区"
          align="center"
          min-width="130"
        />
        <el-table-column
          v-if="!isPropertyMode"
          prop="locationObjName"
          :label="$t('advertManage.table.location')"
          align="center"
        />
        <el-table-column label="广告平台" align="center" width="120">
          <template slot-scope="scope">
            {{ clientTypeName(scope.row.clientType) }}
          </template>
        </el-table-column>
        <el-table-column v-if="isPropertyMode" label="跳转目标" align="center" min-width="180">
          <template slot-scope="scope">
            <div>{{ advertManageInfo.advertTypeName[scope.row.advertType] || "-" }}</div>
            <el-tooltip
              v-if="scope.row.pageUrl"
              :content="scope.row.pageUrl"
              placement="top"
            >
              <div class="jump-target">{{ scope.row.pageUrl }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column v-if="isPropertyMode" prop="seq" label="播放顺序" align="center" width="90" />
        <el-table-column v-if="!isPropertyMode" label="投放地点" align="center" width="120">
          <template slot-scope="scope">
            {{ positionTypeName(scope.row.positionType) }}
          </template>
        </el-table-column>
        <el-table-column v-if="!isPropertyMode" label="投放范围" align="center" width="110">
          <template slot-scope="scope">
            <el-tag :type="scope.row.communityId === '9999' ? 'success' : 'primary'">
              {{ scope.row.communityId === '9999' ? '全局' : '指定小区' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="!isPropertyMode" label="发布来源" align="center" min-width="130">
          <template slot-scope="scope">
            <el-tag :type="scope.row.publisherType === 'PROPERTY' ? 'warning' : 'info'">
              {{ scope.row.publisherType === "PROPERTY" ? "物业发布" : "平台发布" }}
            </el-tag>
            <div v-if="scope.row.publisherStoreName" class="publisher-name">
              {{ scope.row.publisherStoreName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!isPropertyMode"
          :label="$t('advertManage.table.advertType')"
          align="center"
        >
          <template slot-scope="scope">
            {{ advertManageInfo.advertTypeName[scope.row.advertType] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="startTime"
          :label="$t('advertManage.table.startTime')"
          align="center"
        />
        <el-table-column
          prop="endTime"
          :label="$t('advertManage.table.endTime')"
          align="center"
        />
        <el-table-column
          prop="createTime"
          :label="$t('advertManage.table.createTime')"
          align="center"
        />
        <el-table-column
          v-if="isPropertyMode"
          prop="creatorUserName"
          label="创建人"
          align="center"
          width="110"
        />
        <el-table-column label="投放状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="effectiveStateType(scope.row.effectiveState)">
              {{ effectiveStateName(scope.row.effectiveState) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('common.operation')"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <el-button v-if="scope.row.canEdit === 'Y'" size="mini" @click="openEditAdvert(scope.row)">{{
              $t("common.edit")
            }}</el-button>
            <el-button
              v-if="scope.row.canDelete === 'Y'"
              size="mini"
              type="danger"
              @click="openDeleteAdvert(scope.row)"
              >{{ $t("common.delete") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="page.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="page.size"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <add-advert
      ref="addAdvert"
      :management-mode="advertManageInfo.managementMode"
      :managed-communities="managedCommunities"
      @success="handleSuccess"
    />
    <edit-advert
      ref="editAdvert"
      :management-mode="advertManageInfo.managementMode"
      :managed-communities="managedCommunities"
      @success="handleSuccess"
    />
    <delete-advert ref="deleteAdvert" @success="handleSuccess" />
    <write-advert-machine ref="writeAdvertMachine" />
  </div>
</template>

<script>
import { listAdverts } from "@/api/admin/advertManageApi";
import AddAdvert from "@/components/admin/AddAdvert";
import EditAdvert from "@/components/admin/EditAdvert";
import DeleteAdvert from "@/components/admin/DeleteAdvert";
import WriteAdvertMachine from "@/components/admin/WriteAdvertMachine";
import { getMyEnteredCommunitys } from "@/api/community/communityApi";

export default {
  name: "AdvertManageList",
  components: {
    AddAdvert,
    EditAdvert,
    DeleteAdvert,
    WriteAdvertMachine,
  },
  data() {
    return {
      loading: false,
      contextLoaded: false,
      managedCommunities: [],
      advertManageInfo: {
        managementMode: "PLATFORM",
        canPublishGlobal: true,
        clientTypeName: {
          ALL: "全选",
          HARMONY: "鸿蒙元服务",
          WECHAT_MINA: "微信小程序",
          APP: "App",
          H5: "H5",
        },
        positionTypeName: {
          ALL: "全选",
          HOME_BANNER: "首页轮播",
          SPLASH: "开屏",
          WATERFALL: "瀑布流",
          POPUP: "弹窗",
          MALL_BANNER: "商城轮播",
        },
        advertTypeName: [
          "",
          this.$t("advertManage.advertType.site"),
          this.$t("advertManage.advertType.outside"),
          this.$t("advertManage.advertType.noJump"),
        ],
        adverts: [],
        moreCondition: false,
        locationTypeCds: [],
        conditions: {
          adName: "",
          classify: "",
          locationTypeCd: "",
          communityId: "",
          clientType: "",
          effectiveState: "",
        },
      },
      clientTypeOptions: [
        { value: "ALL", label: "全部平台" },
        { value: "HARMONY", label: "鸿蒙元服务" },
        { value: "WECHAT_MINA", label: "微信小程序" },
        { value: "APP", label: "App" },
        { value: "H5", label: "H5" },
      ],
      effectiveStateOptions: [
        { value: "NOT_STARTED", label: "未开始" },
        { value: "ACTIVE", label: "投放中" },
        { value: "ENDED", label: "已结束" },
        { value: "DISABLED", label: "已停用" },
      ],
      classifyOptions: [
        { value: "9001", label: this.$t("advertManage.classify.logistics") },
        { value: "9002", label: this.$t("advertManage.classify.catering") },
        { value: "9003", label: this.$t("advertManage.classify.travel") },
        { value: "9004", label: this.$t("advertManage.classify.hotel") },
        { value: "9005", label: this.$t("advertManage.classify.education") },
        { value: "9006", label: this.$t("advertManage.classify.internet") },
      ],
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
    };
  },
  created() {
    this.getList();
    this.getLocationTypes();
  },
  computed: {
    isPropertyMode() {
      return this.advertManageInfo.managementMode === "PROPERTY";
    },
  },
  methods: {
    async getList() {
      try {
        this.loading = true;
        const params = {
          page: this.page.current,
          row: this.page.size,
          ...this.advertManageInfo.conditions,
        };
        const { data, total, managementMode, canPublishGlobal } = await listAdverts(params);
        this.advertManageInfo.adverts = data;
        this.page.total = total;
        this.advertManageInfo.managementMode = managementMode;
        this.advertManageInfo.canPublishGlobal = canPublishGlobal;
        if (managementMode === "PROPERTY" && !this.contextLoaded) {
          await this.loadManagedCommunities();
        } else if (managementMode !== "PROPERTY") {
          this.contextLoaded = true;
        }
      } catch (error) {
        this.$message.error(this.$t("advertManage.fetchError"));
      } finally {
        this.loading = false;
      }
    },
    async loadManagedCommunities() {
      try {
        const pageSize = 100;
        let currentPage = 1;
        let total = 0;
        const communities = [];
        do {
          const res = await getMyEnteredCommunitys({ page: currentPage, row: pageSize });
          const pageCommunities = res.communitys || [];
          total = Number(res.total || 0);
          communities.push(...pageCommunities);
          if (pageCommunities.length === 0) break;
          currentPage += 1;
        } while (communities.length < total);
        const uniqueCommunities = new Map();
        communities.forEach(item => uniqueCommunities.set(item.communityId, item));
        this.managedCommunities = Array.from(uniqueCommunities.values());
      } catch (error) {
        this.managedCommunities = [];
        this.$message.error(error && error.message ? error.message : "获取可管理小区失败");
      } finally {
        this.contextLoaded = true;
      }
    },
    async getLocationTypes() {
      try {
        // 这里应该调用获取位置类型的API
        // const data = await getLocationTypes()
        // this.advertManageInfo.locationTypeCds = data
      } catch (error) {
        this.$message.error(this.$t("advertManage.fetchLocationError"));
      }
    },
    queryAdvert() {
      this.page.current = 1;
      this.getList();
    },
    resetAdvert() {
      this.advertManageInfo.conditions = {
        adName: "",
        classify: "",
        locationTypeCd: "",
        communityId: "",
        clientType: "",
        effectiveState: "",
      };
      this.getList();
    },
    toggleMoreCondition() {
      this.advertManageInfo.moreCondition =
        !this.advertManageInfo.moreCondition;
    },
    clientTypeName(value) {
      return this.advertManageInfo.clientTypeName[value] || value || "-";
    },
    positionTypeName(value) {
      return this.advertManageInfo.positionTypeName[value] || value || "-";
    },
    effectiveStateName(value) {
      return {
        NOT_STARTED: "未开始",
        ACTIVE: "投放中",
        ENDED: "已结束",
        DISABLED: "已停用",
        UNKNOWN: "未知",
      }[value] || "未知";
    },
    effectiveStateType(value) {
      return {
        NOT_STARTED: "info",
        ACTIVE: "success",
        ENDED: "",
        DISABLED: "danger",
        UNKNOWN: "warning",
      }[value] || "warning";
    },
    openAddAdvert() {
      if (!this.contextLoaded || (this.isPropertyMode && this.managedCommunities.length === 0)) {
        return;
      }
      this.$refs.addAdvert.open();
    },
    openEditAdvert(row) {
      this.$refs.editAdvert.open(row);
    },
    openDeleteAdvert(row) {
      this.$refs.deleteAdvert.open(row);
    },
    viewAdvertPhoto() {
      this.$refs.writeAdvertMachine.open();
    },
    handleSuccess() {
      this.getList();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.advert-manage-container {
  padding: 20px;

  .search-wrapper {
    margin-bottom: 20px;
  }

  .list-wrapper {
    .el-pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}

.publisher-name {
  margin-top: 4px;
  color: #606266;
  font-size: 12px;
}

.jump-target {
  max-width: 170px;
  margin: 4px auto 0;
  overflow: hidden;
  color: #909399;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
